"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISO_3166_1_alpha_2_frenchDROMCodes = void 0;
exports.ISO_3166_1_alpha_2_frenchDROMCodes = [
    'GF',
    'GP',
    'MQ',
    'RE',
    'YT',
];
